import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "Revenue", -1)
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 lg:col-6"
}
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "col-12 lg:col-6" }
const _hoisted_10 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_11 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_12 = {
  key: 2,
  class: "p-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_Chartist = _resolveComponent("Chartist")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.user.isSuperAdmin())
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                key: `statistics_filters_project_id_${_ctx.statisticsFiltersKeyCounter}`,
                modelValue: _ctx.statisticsFilters.project_id,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statisticsFilters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                label: _ctx.$t('project'),
                loading: _ctx.projectsLoading,
                "show-clear": "",
                filter: "",
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name",
                multiple: ""
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.showPublisherDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                key: `statistics_filters_publisher_id_${_ctx.statisticsFiltersKeyCounter}`,
                modelValue: _ctx.statisticsFilters.publisher_id,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.statisticsFilters.publisher_id) = $event)),
                  _ctx.onFilterDropdownChange
                ],
                label: _ctx.$t('publisher'),
                loading: _ctx.usersLoading,
                "show-clear": "",
                filter: "",
                options: _ctx.users.data,
                "option-value": "id",
                "option-label": "compiled_name",
                multiple: ""
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showAdvertiserDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                key: `statistics_filters_advertiser_id_${_ctx.statisticsFiltersKeyCounter}`,
                modelValue: _ctx.statisticsFilters.advertiser_id,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statisticsFilters.advertiser_id) = $event)),
                  _ctx.onFilterDropdownChange
                ],
                label: _ctx.$t('advertiser'),
                loading: _ctx.usersLoading,
                "show-clear": "",
                filter: "",
                options: _ctx.users.data,
                "option-value": "id",
                "option-label": "compiled_name",
                multiple: ""
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFeedDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                key: `statistics_filters_feed_id_${_ctx.statisticsFiltersKeyCounter}`,
                modelValue: _ctx.statisticsFilters.feed_id,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statisticsFilters.feed_id) = $event)),
                  _ctx.onFilterDropdownChange
                ],
                label: _ctx.$t('feed'),
                loading: _ctx.feedsLoading,
                "show-clear": "",
                filter: "",
                options: _ctx.feeds.data,
                "option-value": "id",
                "option-label": "compiled_name",
                multiple: ""
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.statisticsFetched)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_Chartist, {
              class: "activity-chart activity-chart-revenue chartist-no-grid-x",
              key: `chartist_${_ctx.statisticsFiltersKeyCounter}`,
              "show-area": "",
              "show-point": "",
              "axis-y-label-interpolation-function": _ctx.axisYLabelInterpolationFunction,
              "tooltip-options": { currency: '$' },
              entries: _ctx.statistics.data,
              "entry-key": "revenue",
              "entry-description-key": "time"
            }, null, 8, ["axis-y-label-interpolation-function", "entries"]))
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_PrimeVueSkeleton, { height: "120px" })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
          key: 1,
          height: "120px"
        }))
  ]))
}